import { useEffect, useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';

import { JubFunctionEnum } from '../ContactsSecurity/AddEditContactsSecurityModal/ContactSecurity.types';

export const USE_ACCOUNT_MANAGERS_QUERY_KEY = 'useAccountManagers';

const useAccountManagersQuery = (organizationId?: string, jobFunction?: JubFunctionEnum) => {
  const { isLoading, error, data, isSuccess, isError, refetch } = useQuery(
    [USE_ACCOUNT_MANAGERS_QUERY_KEY, organizationId, jobFunction],
    () =>
      api.get(API_URL.CONTACTS_UP_HIERARCHY, {
        params: {
          size: 1000, // Hardcode for fixing pagination on dropdown. In the future will be improved (inifite loading, searching, etc)
          organization_id: organizationId,
          ...(jobFunction
            ? {
                job_function: jobFunction,
              }
            : {}),
        },
      }),
    {
      enabled: organizationId !== undefined,
    }
  );
  useEffect(() => {
    if (organizationId !== undefined) refetch();
  }, [refetch, organizationId]);

  const formatedData = useMemo<Option[]>(() => {
    const list = data?.data?.content || [];
    return list.map((item) => ({
      key: `${item.id}`,
      value: `${item.first_name} ${item.last_name}`,
    }));
  }, [data]);
  return {
    data: formatedData,
    error,
    isError,
    isLoading,
    isSuccess,
  };
};

export default useAccountManagersQuery;
